// extracted by mini-css-extract-plugin
module.exports = {"container":"sO","imgContainer":"tO","content":"uO","brand":"vO","product":"wO","price":"xO","noLink":"yO"};